const TYPE_NOTIFICATION_ERROR = 1;
const TYPE_NOTIFICATION_UNAUTHORIZED = 2;

export const invalidDiscountCode = 704003;
export const expiredDiscountCode = 704004;

export const ERROR_CODE = {
  202: {
    message: 'Invalid credentials',
    type: TYPE_NOTIFICATION_ERROR
  }, // END 202
  401: {
    message: 'Unauthorized user',
    type: TYPE_NOTIFICATION_UNAUTHORIZED
  } // END 401
}; // END ERROR_CODE

export const ERROR_CODE_COUPON = {
  704000: {
    color: 'danger',
    message: 'Error inesperado con la api de stripe, contacta con soporte',
    inputMessage: 'Revisa que tu código sea válido y vuelve a intentar'
  },
  200109: {
    color: 'warning',
    message: 'El cupón ingresado ha expirado',
    inputMessage: 'El cupón ingresado ha expirado'
  },
  200111: {
    color: 'warning',
    message: 'El cupón ingresado es inválido',
    inputMessage: 'El cupón ingresado es inválido'
  },
  200114: {
    color: 'warning',
    message: 'El cupón no se puede aplicar a este plan',
    inputMessage: 'El cupón no se puede aplicar a este plan'
  }
};

export const ERROR_CODE_USERS = {
  134: {
    color: 'danger',
    message: 'No es posible eliminar la cuenta principal'
  },
  146: {
    color: 'warning',
    message: 'El usuario que intentas invitar ya existe dentro de esa Empresa'
  },
  149: {
    color: 'warning',
    message: 'La Empresa a la que intentas invitar no existe'
  },
  151: {
    color: 'warning',
    message: 'No eres parte de la Empresa a la que intentas invitar'
  },
  152: {
    color: 'warning',
    message: 'No es posible eliminar la cuenta owner'
  },
  155: {
    color: 'warning',
    message: 'El usuario ya se encuentra dado de alta. Favor de verificar'
  },
  157: {
    color: 'warning',
    message: 'No es posible cambiar de rol la cuenta owner'
  }
};

export const ERROR_CODE_PAYMENTS = {
  100205: {
    color: 'danger',
    message:
      'El monto del comprobante de pago no coincide con el balance de la factura'
  },
  100206: {
    color: 'warning',
    message:
      'No se pudo subir el comprobante de pago, al menos una factura esta cancelada'
  },
  100207: {
    color: 'warning',
    message:
      'No se pudo subir el comprobante de pago, al menos una factura tiene comprobantes de pago pendiente'
  },
  100208: {
    color: 'warning',
    message: 'Un pago aceptado no se puede rechazar'
  },
  100209: {
    color: 'warning',
    message: 'Un pago rechazado no se puede aceptar'
  }
};



// WEBPACK FOOTER //
// ./src/constants/errorCodes.js